import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { driverApi } from "../../services/driverApi";
import { getPublicSettings } from "../../services/adminApi";
import logo from "../../assets/logo.png";

export default function DriverLogin({ onLogin }) {
  const navigate = useNavigate();
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getPublicSettings().then((d) => setCompanyName(d.companyName || d.companyTradeName || ""));
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { driver } = await driverApi.login(email, phone);
      onLogin(driver);
    } catch (err) {
      setError(err.message || "We couldn't find your account. Double-check your email and phone number.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12" style={{ background: "linear-gradient(160deg, #0d1b3e 0%, #0a0f2c 50%, #060b1f 100%)" }}>
      {/* Subtle glow effects */}
      <div style={{ position: "fixed", inset: 0, pointerEvents: "none", background: "radial-gradient(ellipse 70% 50% at 50% 0%, rgba(59,130,246,0.12) 0%, transparent 60%)" }} />

      <div className="relative z-10 w-full max-w-sm">
        {/* Back */}
        <button
          onClick={() => navigate("/enrollme")}
          className="flex items-center gap-1.5 text-xs text-slate-400 hover:text-slate-200 transition mb-7"
        >
          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Back
        </button>

        {/* Header */}
        <div className="text-center mb-8">
          <img src={logo} alt="EnrollMe" className="h-14 w-14 object-contain rounded-2xl mx-auto mb-5" style={{ boxShadow: "0 4px 24px rgba(0,0,0,0.4)" }} />
          <p className="text-xs font-semibold text-blue-400 uppercase tracking-widest mb-1">Driver Portal</p>
          <h1 className="text-2xl font-bold text-white mb-1" style={{ letterSpacing: "-0.02em" }}>{companyName}</h1>
          <p className="text-slate-400 text-sm">Sign in to track your enrollment progress.</p>
        </div>

        {/* Card */}
        <div className="rounded-2xl p-7" style={{ background: "rgba(15,23,42,0.75)", border: "1px solid rgba(148,163,184,0.15)", backdropFilter: "blur(12px)" }}>
          {error && (
            <div className="rounded-lg px-4 py-3 mb-5 text-sm" style={{ background: "rgba(220,38,38,0.1)", border: "1px solid rgba(220,38,38,0.3)", color: "#fca5a5" }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-xs font-semibold text-slate-400 uppercase tracking-wide mb-2">Email address</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
                placeholder="your@email.com"
                className="w-full rounded-xl px-4 py-3 text-sm text-white placeholder-slate-500 focus:outline-none transition"
                style={{ background: "rgba(15,23,42,0.6)", border: "1px solid rgba(148,163,184,0.18)", boxSizing: "border-box" }}
                onFocus={(e) => { e.target.style.borderColor = "#3b82f6"; e.target.style.boxShadow = "0 0 0 3px rgba(59,130,246,0.15)"; }}
                onBlur={(e) => { e.target.style.borderColor = "rgba(148,163,184,0.18)"; e.target.style.boxShadow = "none"; }}
              />
            </div>
            <div>
              <label className="block text-xs font-semibold text-slate-400 uppercase tracking-wide mb-2">Phone number</label>
              <input
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
                placeholder="The number on file with the office"
                className="w-full rounded-xl px-4 py-3 text-sm text-white placeholder-slate-500 focus:outline-none transition"
                style={{ background: "rgba(15,23,42,0.6)", border: "1px solid rgba(148,163,184,0.18)", boxSizing: "border-box" }}
                onFocus={(e) => { e.target.style.borderColor = "#3b82f6"; e.target.style.boxShadow = "0 0 0 3px rgba(59,130,246,0.15)"; }}
                onBlur={(e) => { e.target.style.borderColor = "rgba(148,163,184,0.18)"; e.target.style.boxShadow = "none"; }}
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full font-semibold py-3 rounded-xl transition disabled:opacity-50 text-sm"
              style={{ background: "linear-gradient(135deg, #3b82f6, #2563eb)", color: "#fff", marginTop: "4px" }}
            >
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>

          <p className="text-center text-xs text-slate-500 mt-5">
            Having trouble? Contact the office and we'll get you sorted.
          </p>
        </div>
      </div>
    </div>
  );
}
